import React, {Component} from "react";
import {Table, Thead, Tbody, Tr, Th, Td} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import moment from "moment";
import { Link } from 'react-router-dom';

import baseURL from "../../../config"
import { formatMoney } from "helpers/currency";

class InvoicingList extends Component {
    dwInvoice(invoiceid) {
    }


  tableRowElement(bookings) {
    if (bookings) {
      return bookings.map((booking) => {
        const toUrl = baseURL+'/api/v1/admins/downloadinvoice/'+booking._id;
        return (
          <Tr key={booking._id}>
            <Td><Link to={toUrl} onClick={() => this.dwInvoice(booking._id)}>{Number(booking.number)}</Link></Td>
            <Td>{moment(booking.createdAt).format('DD MMM YYYY')}</Td>
            <Td>{formatMoney(booking.amount, { locale: "bg" })}</Td>
            <Td>{booking.professional?.name} {booking.professional?.surname}</Td>
          </Tr>
        );
      });
    }
  }

  render() {
    const {list} = this.props;
    return (
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          <Table
            id="tech-companies-1"
            className="table table-striped table-bordered"
          >
            <Thead>
              <Tr>
                <Th data-priority="1">Фактура</Th>
                <Th data-priority="1">Дата на фактурата</Th>
                <Th data-priority="1">Фактурирана сума</Th>
                <Th data-priority="1">Специалист</Th>
              </Tr>
            </Thead>
            <Tbody>{this.tableRowElement(list)}</Tbody>
          </Table>
        </div>

      </div>
    );
  }
}

export default InvoicingList;
